interface PageHeroProps {
  eyebrow: string;
  title: string;
  desc?: string;
  crumbs: { label: string; to?: string }[];
}

export default function PageHero({ eyebrow, title, desc, crumbs }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden bg-secondary-950 pt-16">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=warm%20abstract%20illustration%20of%20scattered%20ink%20strokes%20and%20flying%20sakura%20petals%20on%20a%20deep%20warm%20charcoal%20background%2C%20coral%20and%20amber%20accents%2C%20creative%20culture%20mood%2C%20minimal&width=1600&height=520&seq=page-hero&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 to-secondary-950"></div>
      <div className="relative mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <nav aria-label="面包屑" className="mb-4 flex flex-wrap items-center gap-1.5 text-xs text-background-200/70">
          <a href="/" className="hover:text-accent-300">首页</a>
          {crumbs.map((c, i) => (
            <span key={c.label} className="flex items-center gap-1.5">
              <i className="ri-arrow-right-s-line"></i>
              {c.to ? (
                <a href={c.to} className="hover:text-accent-300">{c.label}</a>
              ) : (
                <span className="text-accent-300">{c.label}</span>
              )}
              {i < crumbs.length - 1 ? null : null}
            </span>
          ))}
        </nav>
        <p className="text-sm font-medium uppercase tracking-widest text-accent-300">{eyebrow}</p>
        <h1 className="font-heading mt-2 text-3xl font-bold text-background-50 md:text-4xl">{title}</h1>
        {desc && <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">{desc}</p>}
      </div>
    </section>
  );
}